<div class="batch-bom">
  @if (bomLoading$ | async) {
    <h3>
      <span class="skeleton-box w-4/5"></span>
      <span class="skeleton-box w-11/12"></span>
    </h3>
    <hr class="border-b-1 my-2 h-0.5 bg-gray-300 opacity-100 dark:opacity-50" />
    <h4 class="pt-2">
      <span class="skeleton-box w-3/5"></span>
    </h4>
    <div class="pt-4">
      <span class="skeleton-box w-1/2"></span><br />
      <span class="skeleton-box w-1/2"></span>
    </div>
    <div class="pt-4">
      <span class="skeleton-box w-1/2 text-5xl"></span>
    </div>
    <div class="pt-4">
      <span class="skeleton-box w-1/2"></span><br />
      <span class="skeleton-box w-1/2"></span>
    </div>
  } @else {
    @if (dataState === ComponentDataState.HasData) {
      <h3 class="text-base font-semibold leading-6 text-gray-900">
        {{ bom.description }}
      </h3>
      <hr
        class="border-b-1 my-2 h-0.5 bg-gray-300 opacity-100 dark:opacity-50"
      />
      <div class="pt-2">
        <h4 class="text-base font-semibold text-gray-900">
          External Article ID:
        </h4>
        <span class="text-base font-semibold text-gray-500">{{
          bom.externalArticleId
        }}</span>
      </div>
      <div class="pt-4">
        <h4 class="text-base font-semibold text-gray-900">FIP Article ID:</h4>
        <span class="text-base font-semibold text-gray-500">{{
          bom.articleId
        }}</span>
      </div>
      @if (bom.children.length) {
        <div class="pt-4">
          <fip-form>
            <mat-form-field>
              <mat-label>Batches</mat-label>
              <mat-select
                #batches
                [formControl]="batchesControl"
                multiple
                (valueChange)="selectBatch.emit(batches.value)"
              >
                @for (BatchId of selectedBatchIds; track BatchId) {
                  <mat-option [value]="BatchId">
                    {{ BatchId }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="pt-4">
              <mat-label>Company</mat-label>
              <mat-select
                #companies
                [formControl]="companyControl"
                multiple
                (valueChange)="selectCompanies(companies.value)"
              >
                @for (company of allCompanies; track company) {
                  <mat-option [value]="company.code">
                    {{ company.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </fip-form>
        </div>
        <div class="pt-24">
          <fip-form formType="slide">
            <mat-slide-toggle
              [formControl]="showBomControl"
              data-cy="show-bom-tree-toggle"
            >
              <mat-icon class="mr-2">list</mat-icon>
              Show BOM
            </mat-slide-toggle>
          </fip-form>
        </div>
        @if (showBomControl.value) {
          <div class="-ml-3 -mr-2 pt-5" data-cy="bom-tree">
            @if (nestedDataSource.data.length) {
              <mat-tree
                [dataSource]="nestedDataSource"
                [treeControl]="nestedTreeControl"
                class="border-t border-light-grey"
              >
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                  <mat-button
                    matTreeNodeToggle
                    labelTextClass="text-md text-gray-800"
                    class="w-full cursor-pointer select-none"
                    [ngClass]="
                      'flex items-center px-2 py-3 ' +
                      (selectedArticleId === node?.articleId
                        ? 'bg-accent-yellow'
                        : 'bg-gray-100')
                    "
                    (click)="selectArticleId(node.articleId)"
                    >{{ node?.articleId }}
                    <ng-container
                      [ngTemplateOutlet]="interFactoryIcon"
                      [ngTemplateOutletContext]="{
                        node: node,
                      }"
                    />
                  </mat-button>
                </mat-tree-node>
                <mat-nested-tree-node
                  *matTreeNodeDef="let node; when: hasNestedChild"
                  matTreeNodePadding
                  class="mb-2"
                >
                  <div class="mat-tree-node">
                    <mat-button
                      mat-flat-button
                      class="w-full cursor-pointer select-none"
                      matTreeNodeToggle
                      [ngClass]="
                        'flex items-center px-2 py-3 ' +
                        (selectedArticleId === node?.articleId
                          ? 'bg-accent-yellow'
                          : 'bg-gray-100')
                      "
                      (click)="selectArticleId(node.articleId)"
                    >
                      <mat-icon>{{
                        nestedTreeControl.isExpanded(node)
                          ? 'expand_more'
                          : 'chevron_right'
                      }}</mat-icon>
                      {{ node?.articleId }}
                      <ng-container
                        [ngTemplateOutlet]="interFactoryIcon"
                        [ngTemplateOutletContext]="{ node: node }"
                      />
                    </mat-button>
                  </div>
                  <div
                    class="nested-node"
                    [class.hidden]="!nestedTreeControl.isExpanded(node)"
                  >
                    <ng-container matTreeNodeOutlet></ng-container>
                  </div>
                </mat-nested-tree-node>
              </mat-tree>
            }
          </div>
        }
      }
    }
    @if (dataState === ComponentDataState.NoData) {
      No BOM data available.
    }
  }
</div>

<ng-template #interFactoryIcon let-node="node">
  @if ($safeNavigationMigration(node?.interFactoryCompanyCode) !== null) {
    <mat-icon
      style="margin-left: auto"
      [matTooltip]="
        'Article originally created in factory: ' +
        getFactoryNameFromCode(
          $safeNavigationMigration(node?.interFactoryCompanyCode)
        )
      "
      >compare_arrows
    </mat-icon>
  }
</ng-template>
